import React from "react";
import { Line, Bar, Pie, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import StatisticCard from "./StatisticCard";
import StatisticCharts from "./StatisticCharts";

// Register necessary Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement, // For Bar chart
  ArcElement, // For Pie chart
  RadialLinearScale, // Register RadialLinearScale for Radar chart
  Title,
  Tooltip,
  Legend
);

export default function AnalyticsMain() {
  // Data for the chart
  const data = {
    labels: ["January", "February", "March", "April", "May", "June"], // X-axis labels
    datasets: [
      {
        label: "Sales Over Time",
        data: [65, 59, 80, 81, 56, 55], // Y-axis data
        fill: false,
        borderColor: "rgba(75,192,192,1)",
        tension: 0.1,
      },
    ],
  };

  const barData = {
    labels: ["January", "February", "March", "April", "May", "June"],
    datasets: [
      {
        label: "Sales Over Time",
        data: [65, 59, 80, 81, 56, 55],
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1,
      },
    ],
  };

  const pieData = {
    labels: ["January", "February", "March", "April", "May", "June"],
    datasets: [
      {
        label: "Sales Distribution",
        data: [65, 59, 80, 81, 56, 55],
        backgroundColor: [
          "rgba(75,192,192,0.2)",
          "rgba(255,99,132,0.2)",
          "rgba(255,159,64,0.2)",
          "rgba(153,102,255,0.2)",
          "rgba(255,159,64,0.2)",
          "rgba(54,162,235,0.2)",
        ],
        borderColor: [
          "rgba(75,192,192,1)",
          "rgba(255,99,132,1)",
          "rgba(255,159,64,1)",
          "rgba(153,102,255,1)",
          "rgba(255,159,64,1)",
          "rgba(54,162,235,1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const radarData = {
    labels: ["January", "February", "March", "April", "May", "June"],
    datasets: [
      {
        label: "Sales Over Time",
        data: [65, 59, 80, 81, 56, 55],
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1,
      },
    ],
  };

  // Options for the chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Months",
        },
      },
      y: {
        title: {
          display: true,
          text: "Sales",
        },
        min: 0, // Minimum value of y-axis
        max: 100, // Maximum value of y-axis
      },
    },
  };

  return (
    <>
      <StatisticCard />
      <StatisticCharts />
    </>
  );
}
